var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9987 0.666992V2.00033H9.9987V0.666992H11.332V2.00033H13.9987C14.3669 2.00033 14.6654 2.29881 14.6654 2.66699V13.3337C14.6654 13.7019 14.3669 14.0003 13.9987 14.0003H1.9987C1.63051 14.0003 1.33203 13.7019 1.33203 13.3337V2.66699C1.33203 2.29881 1.63051 2.00033 1.9987 2.00033H4.66536V0.666992H5.9987ZM13.332 7.33366H2.66536V12.667H13.332V7.33366ZM5.33203 9.33366V10.667H3.9987V9.33366H5.33203ZM11.9987 9.33366V10.667H6.66536V9.33366H11.9987ZM4.66536 3.33366H2.66536V6.00033H13.332V3.33366H11.332V4.66699H9.9987V3.33366H5.9987V4.66699H4.66536V3.33366Z",
    fill: "#A3A3A3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.8c759bdfcd2316af112d013bc1b3e0d4.svg";
export { ForwardRef as ReactComponent };